import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'departments/'

const initialState = {
    departments: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getDepartments = createAsyncThunk('dept/ged', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleDepartment = createAsyncThunk('dept/gsd', async (deptID, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}${deptID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addDepartment = createAsyncThunk('dept/ad', async (deptData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, deptData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editDepartment = createAsyncThunk('dept/ed', async (deptData, thunkAPI) => {
    try {
        const result = await axios.put(`${API_URL}${deptData.deptID}`, deptData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteDepartment = createAsyncThunk('dept/dd', async (deptID, thunkAPI) => {
    try {
        const result = await axios.delete(`${API_URL}${deptID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const departmentSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.employeeList = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getDepartments.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDepartments.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.departments = action.payload
            })
            .addCase(getDepartments.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.employeeList = []
            })
    }
})

export const { reset } = departmentSlice.actions

export default departmentSlice.reducer
